import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";

const Container = styled.div`
  display: flex;
  align-contet:center;
  justify-content: center;
  align-items: flex-start; /* 화면 상단에 배치 */
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 20px 50px; /* 위쪽 padding을 줄여서 상단에 가까워지도록 조정 */
`;

const FormBox = styled.div`
  margin-top:120px;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  color: #333;
  text-align: center;
  margin-bottom: 1.5rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
`;

const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  box-sizing: border-box;
`;

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  background-color: #0056b3;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  box-sizing: border-box;

  &:hover {
    background-color: #003d82;
  }
`;

const Message = styled.p`
  color: #d32f2f;
  text-align: center;
  margin-bottom: 1rem;
`;

const StyledLink = styled(Link)`
  display: block;
  text-align: center;
  color: #0056b3;
  text-decoration: none;
  margin-top: 1rem;

  &:hover {
    text-decoration: underline;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const RadioInput = styled.input`
  margin-right: 0.5rem;
`;

function RegisterForm() {
  const [username, setUsername] = useState("");
  const [registerId, setRegisterId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [gender, setGender] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthDay, setBirthDay] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [alias, setAlias] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [industryType, setIndustryType] = useState("");
  const [businessCategory, setBusinessCategory] = useState("");
  const [address, setAddress] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const validateForm = () => {
    if (
      registerId.length > 0 &&
      username.length > 0 &&
      password.length > 0
    ) {
      if (password !== confirmPassword) {
        setMessage("비밀번호가 일치하지 않습니다.");
        return false;
      }
      return true;
    } else {
      setMessage("모든 필드를 채워주세요.");
      return false;
    }
  };

  const handleSubmitRegister = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      try {
        const response = await fetch("/request/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: registerId,
            user_name: username,
            user_pwd: password,
            gender: gender,
            birth_y: birthYear,
            birth_m: birthMonth,
            birth_d: birthDay,
            email: email,
            phone: phone,
            alias: alias,
            company_name: companyName,
            business_number: businessNumber,
            representative_name: representativeName,
            industry_type: industryType,
            business_category: businessCategory,
            address: address,
          }),
        });

        if (!response.ok) throw new Error(response.statusText);
        alert(`${username}님, 회원가입이 성공적으로 완료되었습니다.`);
        navigate("/Login");
      } catch (error) {
        console.error("회원가입 실패: ", error);
        setMessage("회원가입에 실패하였습니다.");
      }
    }
  };

  return (
    <Container>
      <FormBox>
        <form onSubmit={handleSubmitRegister}>
        <main style={{display:'flex' ,justifyContent:'center'}}>
        <section style={{width:'70%',margin:'10px'}}>
          <Title  as="h3">Register</Title>
          <Message>{message}</Message>
          <Input
            type="text"
            placeholder="ID"
            required
            value={registerId}
            onChange={(e) => setRegisterId(e.target.value)}
          />
          <Input
            type="text"
            placeholder="이름"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <Input
            type="text"
            placeholder="별칭"
            required
            value={alias}
            onChange={(e) => setAlias(e.target.value)}
          />
          <Input
            type="password"
            placeholder="비밀번호"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            type="password"
            placeholder="비밀번호 확인"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <RadioGroup>
            <RadioLabel>
              <RadioInput
                type="radio"
                name="gender"
                value="1"
                checked={gender === "1"}
                onChange={(e) => setGender(e.target.value)}
              />
              남성
            </RadioLabel>
            <RadioLabel>
              <RadioInput
                type="radio"
                name="gender"
                value="2"
                checked={gender === "2"}
                onChange={(e) => setGender(e.target.value)}
              />
              여성
            </RadioLabel>
          </RadioGroup>
          <Input
            name="birth_y"
            type="text"
            placeholder="생년 (YYYY)"
            value={birthYear}
            onChange={(e) => setBirthYear(e.target.value)}
          />
          <Select
            name="birth_m"
            value={birthMonth}
            onChange={(e) => setBirthMonth(e.target.value)}
          >
            <option value="">월 선택</option>
            {[...Array(12)].map((_, i) => (
              <option key={i} value={String(i + 1).padStart(2, "0")}>
                {i + 1}월
              </option>
            ))}
          </Select>
          <Input
            type="text"
            placeholder="생일 (DD)"
            value={birthDay}
            onChange={(e) => setBirthDay(e.target.value)}
          />
          <Input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            type="text"
            placeholder="전화번호"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button type="submit">회원가입</Button>
          </section>
          {/* <section style={{width:'45%',margin:'10px'}}>
          <Title as="h3">Business Information</Title>
          <Input
            type="text"
            placeholder="회사명"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
          <Input
            type="text"
            placeholder="사업자 번호"
            value={businessNumber}
            onChange={(e) => setBusinessNumber(e.target.value)}
          />
          <Input
            type="text"
            placeholder="대표자명"
            value={representativeName}
            onChange={(e) => setRepresentativeName(e.target.value)}
          />
          <Input
            type="text"
            placeholder="업종"
            value={industryType}
            onChange={(e) => setIndustryType(e.target.value)}
          />
          <Input
            type="text"
            placeholder="업태"
            value={businessCategory}
            onChange={(e) => setBusinessCategory(e.target.value)}
          />
          <Input
            type="text"
            placeholder="주소"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          </section> */}
        </main>
          
        </form>
      </FormBox>
    </Container>
  );
}

function Login() {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const validateForm = () => {
    if (!userId) {
      setMessage("아이디를 입력해주세요.");
      return false;
    }
    if (!password) {
      setMessage("비밀번호를 입력해주세요.");
      return false;
    }
    setMessage("");
    return true;
  };

  const handleLoginClick = async () => {
    if (validateForm()) {
      try {
        const response = await fetch("/request/Login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId, user_pwd: password }),
          credentials: "include",
        });
        if (response.ok) {
          const userData = await response.json();
          alert(`${userData.name}님, 로그인에 성공하였습니다!`);
          login(userData);
          const urlParams = new URLSearchParams(window.location.search);
          const redirect = urlParams.get("redirect") || "/Tiketting/AssignOrder";
          navigate(redirect);
        } else {
          if (response.status === 401) {
            setMessage("아이디 또는 비밀번호가 잘못되었습니다.");
          } else {
            setMessage("로그인에 실패하였습니다. 다시 시도해주세요.");
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setMessage("로그인 요청 중 문제가 발생했습니다.");
      }
    }
  };

  return (
    <Container>
      <FormBox>
        <Title>Log In</Title>
        <Message>{message}</Message>
        <Input
          type="text"
          name="id"
          placeholder="ID"
          required
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <Input
          type="password"
          name="password"
          placeholder="비밀번호"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="button" onClick={handleLoginClick}>
          로그인
        </Button>
        <StyledLink to="/Register">회원가입</StyledLink>
      </FormBox>
    </Container>
  );
}

export { RegisterForm, Login };
